import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import VideoPromoSection from './components/VideoPromoSection';
import BrandStorySection from './components/BrandStorySection';
import PillarsSection from './components/PillarsSection';
import HowItWorksSection from './components/HowItWorksSection';
import WhyFreshhlockSection from './components/WhyFreshhlockSection';
import PartnerCTASection from './components/PartnerCTASection';
import QuizSection from './components/QuizSection';
import TestimonialsSection from './components/TestimonialsSection';
import InsightsSection from './components/InsightsSection';
import FinalCTASection from './components/FinalCTASection';
import IceCrystalRain from './components/IceCrystalRain';

export default function Home() {
  return (
    <>
      <Navbar />
      <IceCrystalRain />
      <main>
        <HeroSection />
        <VideoPromoSection />
        <BrandStorySection />
        <PillarsSection />
        <HowItWorksSection />
        <WhyFreshhlockSection />
        <PartnerCTASection />
        <QuizSection />
        <TestimonialsSection />
        <InsightsSection />
        <FinalCTASection />
      </main>
      <Footer />
    </>
  );
}